import React, {PureComponent, ReactNode} from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import Text from '/component/base/Text';
import {withStatusBar} from '/provider/StatusBarProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {getErrorTrackingUtilDefaultInstance} from '/util/error-tracking/error-tracking.util';
import {withHOC} from '/util/hoc.util';

import {styles} from './ErrorBoundaryProvider.style';
interface ErrorBoundaryProviderProps {
  onGoBack: () => void;
  statusBarSetDarkText: () => void;
  hasBack: boolean;
  ts: (key: string, fallback: string) => string;
  children: ReactNode;
}
interface ErrorBoundaryProviderState {
  hasError: boolean;
}
export class ErrorBoundaryProvider extends PureComponent<
  ErrorBoundaryProviderProps,
  ErrorBoundaryProviderState
> {
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  state: ErrorBoundaryProviderState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ErrorBoundaryProviderState {
    return {hasError: true};
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidCatch(error: Error) {
    getErrorTrackingUtilDefaultInstance().trackError(error, 'UI Error');
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    const {statusBarSetDarkText = noop} = this.props;
    statusBarSetDarkText();
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {
      onGoBack = noop,
      hasBack = false,
      ts = (_k, fallback) => fallback,
      children = null,
    } = this.props;
    const {hasError} = this.state;

    if (hasError) {
      return (
        <View style={styles.container}>
          <Text style={styles.title} variant="heading">
            {ts('title', 'Unexpected Error')}
          </Text>
          <Text style={styles.message} variant="subheading">
            {ts(
              'message',
              'Apologies for the inconvenience, we’ve encountered a problem. Please reach out to support if this problem continues or you feel you’ve received this message by mistake.',
            )}
          </Text>
          {hasBack ? (
            <Button onPress={onGoBack}>{ts('goBack', 'Go Back')}</Button>
          ) : null}
        </View>
      );
    }

    return children;
  }
}

export default withHOC(
  withStatusBar,
  withTranslation('errorBoundary'),
)(ErrorBoundaryProvider);
